import { OpenSnackbarType } from "components/haven-design/snackbar/use-snackbar";
import { userLoginToken } from "utils/general-utils";

export const downloadTomlFiles = async (openSnackbar?: OpenSnackbarType): Promise<void> => {
  const token = userLoginToken();
  try {
    const response = await fetch("/api/forms/dl/toml", {
      method: "GET",
      headers: {
        "Content-Type": "application/zip",
        "authorization": `Bearer ${token}`,
      },
    });
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "forms.zip"); // or another dynamic name based on date or other criteria
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  } catch (error) {
    console.error("Error downloading the TOML files:", error);
    if (openSnackbar) openSnackbar({ message: "Error downloading the TOML files", status: "error" });
  }
};

